import script from "./DriveRajantView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriveRajantView.vue?vue&type=script&setup=true&lang=ts"

import "./DriveRajantView.vue?vue&type=style&index=0&id=60808433&lang=css"

const __exports__ = script;

export default __exports__